import { captureError } from '@smg-real-estate/browser-rum';
import { type HydrationPayload, useExperimentsStore } from '@smg-real-estate/openfeature-vue';
import { onBeforeUnmount, onMounted } from 'vue';

const EXPERIMENTS_REFRESH_QUERY_PARAM = '__internal_refresh_experiments';
const ONETRUST_CONSENT_COOKIE = 'OptanonConsent=';

const refreshExperiments = async (hydrate: (payload: HydrationPayload) => void): Promise<void> => {
  const refreshUrl = new URL(window.location.href);
  refreshUrl.searchParams.set(EXPERIMENTS_REFRESH_QUERY_PARAM, '1');

  const response = await fetch(refreshUrl.toString(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to refresh experiments: ${response.status}`);
  }

  hydrate((await response.json()) as HydrationPayload);
};

export const useExperimentConsentRefresh = (): void => {
  const experimentsStore = useExperimentsStore();

  const refreshOnConsent = () => {
    void refreshExperiments(experimentsStore.hydrate).catch(captureError);
  };

  onMounted(() => {
    window.addEventListener('optanonHandler', refreshOnConsent);

    if (document.cookie.includes(ONETRUST_CONSENT_COOKIE)) {
      refreshOnConsent();
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('optanonHandler', refreshOnConsent);
  });
};
